import React from 'react';
import { Navigate } from 'react-router-dom';
import {
  OPEN_NO_AGENDAMIENTO_STATE_KEY,
  type OpenNoAgendamientoState,
} from '../components/psychologist/patients/no-agendamiento/noAgendamientoFormSchema';

/**
 * `/patients/no-schedule` ya no es una página propia — el formulario pasó a ser un popup
 * (ver NoAgendamientoModal). Esta ruta se mantiene solo por compatibilidad con links viejos
 * que puedan seguir apuntando acá (o a `/noagendamiento`, que redirige a esta) desde afuera
 * del repo: redirige a `/patients` pidiéndole, vía `state`, que abra el popup con estos
 * mismos datos apenas monte.
 */
export const NoAgendamientoEmbed: React.FC = () => {
  const search = typeof window !== 'undefined' ? window.location.search : '';
  const params = new URLSearchParams(search);
  const processId = params.get('process_id') || '';
  const patientEmail = params.get('patient_email') || '';
  const psychologistEmail = params.get('psychologist_email') || '';

  if (!processId || !patientEmail || !psychologistEmail) {
    return <Navigate to="/patients" replace />;
  }

  const state: OpenNoAgendamientoState = {
    [OPEN_NO_AGENDAMIENTO_STATE_KEY]: {
      processId,
      patientEmail,
      patientName: params.get('patient') || '',
      psychologistEmail,
      totalSessionsGrade: params.get('total_sessions') || undefined,
    },
  };

  return <Navigate to="/patients" state={state} replace />;
};

export default NoAgendamientoEmbed;
